<ng-container *ngIf="!maintenanceMode" class="mat-app-background">
  <app-logo-loader
    id="logo-loader"
    *ngIf="!routingReady"
    [logo]="logoImageSource"
  ></app-logo-loader>
  <router-outlet></router-outlet>
  <app-footer *ngIf="!onCheckingNotAvailableRouters()"></app-footer>
</ng-container>
